import { useEffect, useState } from "react";
import { onAuthStateChanged, setPersistence, browserLocalPersistence } from "firebase/auth";
import { auth } from "../firebase/config";

export function useAuth() {
  const [usuario, setUsuario] = useState(null);
  const [carregandoAuth, setCarregandoAuth] = useState(true);

  useEffect(() => {
    let unsubscribe = () => {};

    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        unsubscribe = onAuthStateChanged(auth, (user) => {
          setUsuario(user);
          setCarregandoAuth(false);
        });
      })
      .catch(() => {
        unsubscribe = onAuthStateChanged(auth, (user) => {
          setUsuario(user);
          setCarregandoAuth(false);
        });
      });

    return () => unsubscribe();
  }, []);

  return { usuario, carregandoAuth };
}
